import React, { useState } from 'react';
import { apiHolder as api } from 'api';
import { Select, Tooltip } from 'antd';
import './host-change.scss';
const systemApi = api.api.getSystemApi();
import Styles from './host-change.module.scss';
import { ReactComponent as IconWarn } from '@/images/icons/icon-warn.svg';
import { getIn18Text } from 'api';
const HostChange = () => {
    const [hostType, setHostType] = useState(() => systemApi.getCurrentHostType());
    const handleHostTypeChanged = (value) => {
        setHostType(value);
        systemApi.setCurrentHostType(value);
        if (window.electronLib) {
            window.electronLib.windowManage.reload();
        }
        else {
            systemApi.jumpToWebHostLogin();
        }
    };
    return (React.createElement("div", { className: Styles.hostChangeContainer },
        React.createElement(Select, { defaultValue: hostType, onChange: handleHostTypeChanged, bordered: false, size: "small", virtual: false, dropdownClassName: "host-change-dropdown", suffixIcon: React.createElement("i", { className: Styles.expandIcon }) },
            React.createElement(Select.Option, { value: "smartDNSHost" }, getIn18Text('MORENXIANLU')),
            React.createElement(Select.Option, { value: "domestic" }, getIn18Text('GUONEIXIANLU'))),
        React.createElement(Tooltip, { title: getIn18Text('LIANJIEVPN'), overlayClassName: Styles.hostChangeTooltip, placement: "bottomRight" },
            React.createElement("span", { className: Styles.tooltipIcon },
                React.createElement(IconWarn, { style: { cursor: 'pointer', marginLeft: '-2px', width: '13px', height: '13px' } })))));
};
export default HostChange;
